import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import Switch from 'react-switch'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'

const EggsPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    ContainerSize: item.ContainerSize,
    CASEFSCompliantCertification: item.CASEFSCompliantCertification,
    EggShellColorCertification: item.EggShellColorCertification,
  })

  const methods = useFormContext()
  const { setSwitchReviewer, asterisk } = useFormUtils()

  useEffect(() => {
    if (item !== null) {
      const {
        ContainerSize,
        CASEFSCompliantCertification,
        EggShellColorCertification,
      } = item

      setPackaging({
        ContainerSize,
        CASEFSCompliantCertification,
        EggShellColorCertification,
      })
    }
    // eslint-disable-next-line
  }, [item])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <h6>Size {asterisk}</h6>
          <Input defaultValue={packaging.ContainerSize} disabled />
        </FormGroup>
      </Col>
      <Col xs={6}>
        <p>
          <strong>
            I verify that this product is CA SEFS Compliant. A product
            image displaying this compliance seal is uploaded below.
            {' '}
            {asterisk}
          </strong>
        </p>
        <Controller
          as={Switch}
          name="CASEFSCompliantCertification"
          id="CASEFSCompliantCertification"
          defaultValue={packaging.CASEFSCompliantCertification}
          onChange={([checked, event, id]) => {
            setSwitchReviewer(item, checked, event, id)
            return checked
          }}
          control={methods.control}
          rules={{
            validate: CASEFSCompliantCertification =>
              CASEFSCompliantCertification === true,
          }}
          disabled={isDisabled}
        />
        <br />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="CASEFSCompliantCertification"
            message={'⚠ Product must be CA SEFS Compliant.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <hr />
        <p>
          <strong>
            I confirm that the egg shell color is white. A product image
            displaying the color of the egg shell is uploaded below.
            {' '}
            {asterisk}
          </strong>
        </p>
        <Controller
          as={Switch}
          name="EggShellColorCertification"
          id="EggShellColorCertification"
          defaultValue={packaging.EggShellColorCertification}
          onChange={([checked, event, id]) => {
            setSwitchReviewer(item, checked, event, id)
            return checked
          }}
          control={methods.control}
          rules={{
            validate: EggShellColorCertification =>
              EggShellColorCertification === true,
          }}
          disabled={isDisabled}
        />
        <br />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="EggShellColorCertification"
            message={'⚠ Egg shell color must be white.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
      </Col>
    </Row>
  )
}

EggsPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default EggsPackageReview
